import React, { useState } from 'react';

import Button from 'views/site/Button.js';
import Icon from 'views/site/Icon.js';
import Theme from 'styles/Theme.js';
import Utils from 'files/Utils.js';

/*
 * ProductCard
 *
 * Ported from the storefront with the entire commercial half removed: no
 * price, no compare-at, no instalments, no volume pricing badge, and no
 * serviceability gate deciding whether any of it may be shown. A dealership
 * quotes after seeing the home, so the card's job ends at "add this to the
 * list I want quoted".
 */

const ProductCard = ({ onAddToQuote, onViewDetails, product }) => {

    const [hover, setHover] = useState(false);

    const onAddClick = evt => {
        // the whole card is a link to the detail view
        evt.stopPropagation();
        if(onAddToQuote) {
            onAddToQuote(product);
        }
    }

    return (
        <div
        onClick={onViewDetails}
        onMouseEnter={setHover.bind(this, true)}
        onMouseLeave={setHover.bind(this, false)}
        style={{
            ...Theme.styles.card(),
            boxShadow: hover ? Theme.boxShadow.cardHover : Theme.boxShadow.card,
            cursor: 'pointer',
            display: 'flex',
            flexDirection: 'column',
            maxWidth: 360,
            transform: hover ? 'translateY(-4px)' : 'translateY(0)',
            width: '100%'
        }}>
            <div style={{
                alignItems: 'center',
                backgroundColor: Theme.colors.offWhite,
                display: 'flex',
                height: 280,
                justifyContent: 'center',
                overflow: 'hidden',
                position: 'relative',
                width: '100%'
            }}>
                {product.images?.length > 0 ? (
                    <img
                    alt={product.images[0].altText || product.title}
                    src={product.images[0].src}
                    style={{
                        height: '100%',
                        objectFit: 'cover',
                        transform: hover ? 'scale(1.05)' : 'scale(1)',
                        transition: 'transform 0.5s ease',
                        width: '100%'
                    }} />
                ) : (
                    <Icon
                    color={Theme.colors.primary()}
                    name={product.icon || 'box-seam'}
                    size={64}
                    style={{
                        opacity: 0.7,
                        transform: hover ? 'scale(1.1)' : 'scale(1)',
                        transition: 'transform 0.5s ease'
                    }} />
                )}
            </div>

            <div style={{
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                padding: 24
            }}>
                <span style={{
                    ...Theme.textStyles.label(),
                    marginBottom: 8
                }}>{product.subtitle || product.category}</span>

                <span style={{
                    ...Theme.textStyles.subHeading(),
                    marginBottom: 8
                }}>{product.title}</span>

                <span style={{
                    ...Theme.textStyles.body({ fontSize: 14 }),
                    display: '-webkit-box',
                    marginBottom: 14,
                    overflow: 'hidden',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 3
                }}>{Utils.truncateText(product.description, 130)}</span>

                <div style={{ flexGrow: 1 }} />

                <span
                onClick={onAddClick}
                style={{ display: 'block', marginTop: 8 }}>
                    <Button
                    icon={'plus-lg'}
                    label={'Add to My Network'}
                    onClick={onAddClick}
                    style={{ fontSize: 14, padding: '12px 20px', width: '100%' }}
                    type={'primary'} />
                </span>
            </div>
        </div>
    )
}

export default ProductCard;
